import { FlowDefinition } from "../../core/flows/FlowDefinition";
import { StepDefinition } from "../../core/flows/StepDefinition";
import { checkoutStepDefinition } from "../CheckoutPage/CheckoutStartup";
import { FavouriteDepartureInitStepDeclaration } from "./Steps/FavouriteDepartureInitStep";
import { FavouriteDepartureTransition } from "./Transition/FavouriteDepartureTransition";

export const favouriteDepartureStartupFlow = new FlowDefinition("FavouriteDepartureFlow");

favouriteDepartureStartupFlow.addStep(FavouriteDepartureInitStepDeclaration);
favouriteDepartureStartupFlow.addStep(checkoutStepDefinition);

favouriteDepartureStartupFlow.addLink("FavouriteDepartureInit_Step", "CheckoutFlow")

favouriteDepartureStartupFlow.addTransition(FavouriteDepartureTransition, "FavouriteDepartureInit_Step")

favouriteDepartureStartupFlow.setStartStep("FavouriteDepartureInit_Step");

export const FavouriteDepartureStartupStepDefinition = new StepDefinition({
    stepName: "FavouriteDepartureFlow",
    stepFlow: favouriteDepartureStartupFlow,
    contextIsolation: false
})
